/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-11-18 16:58:53
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Card, DataTable, Tooltip, Spinner } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import classnames from 'classnames';
import history from 'src/routes/history';

type Props = {
  title?: string,
  linkDetail?: string,
  dataTableProps: any,
  smallRow?: boolean,
  transparent: boolean,
  tooltip?: string,
  loading?: boolean
};
type ComposedProps = Props & WithI18nProps;
// DONE
class AnalyticsTable extends Component<ComposedProps> {
  render() {
    const {
      title,
      linkDetail,
      smallRow,
      transparent,
      dataTableProps,
      tooltip,
      loading,
      i18n,
      className,
      style = {}
    } = this.props;
    const tableClass = classnames(
      'BC-analytics-table',
      { 'BC-analytics-table--small': smallRow },
      { 'BC-analytics-table--transparent': transparent },
      { [className]: className }
    );
    return (
      <div className={tableClass} style={style}>
        <Card
          sectioned
          title={
            <Tooltip content={tooltip} preferredPosition="above">
              <h2 className="Polaris-Heading">{title}</h2>
            </Tooltip>
          }
          actions={
            linkDetail && !loading
              ? [
                  {
                    content: i18n.translate('AdminHTML.Analytics.Common.viewReport'),
                    onAction: this.handleGoToDetail
                  }
                ]
              : []
          }>
          {loading ? (
            <div className="BC-chart-loading">
              <Spinner size="large" />
            </div>
          ) : (
            <DataTable {...dataTableProps} />
          )}
        </Card>
      </div>
    );
  }

  handleGoToDetail = () => {
    const { linkDetail } = this.props;
    history.push(linkDetail);
  };
}

export default withI18n()(AnalyticsTable);
